import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar } = FiIcons;

const SocialProof = () => {
  const testimonials = [
    {
      text: "Our trip to Greece was absolutely flawless. SeetaLuxuryEscape handled everything—even a last-minute flight change. We felt like VIPs the entire time!",
      author: "Michelle L.",
      location: "Toronto",
      rating: 5
    },
    {
      text: "Booking with SeetaLuxuryEscape was the best travel decision we ever made. The private tour in Mexico was unforgettable!",
      author: "The Patel Family",
      location: "Vancouver",
      rating: 5
    },
    {
      text: "Exceptional service and attention to detail. Our Caribbean honeymoon was pure magic thanks to their expertise.",
      author: "Sarah & David",
      location: "Calgary",
      rating: 5
    }
  ];

  const partners = [
    "TripAdvisor", "Google Reviews", "Expedia", "Booking.com", "Air Canada", "WestJet"
  ];

  return (
    <section className="py-16 relative bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Partner Logos */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="backdrop-blur-xl bg-black/60 rounded-2xl p-8 border border-orange-500/30 shadow-xl mb-12"
        >
          <p className="text-center text-orange-200 mb-6 font-medium">Trusted by thousands of Canadian travelers</p>
          <div className="flex flex-wrap justify-center items-center gap-8">
            {partners.map((partner, index) => (
              <div key={index} className="text-gray-300 font-semibold text-sm sm:text-base hover:text-orange-400 transition-colors">
                {partner}
              </div>
            ))}
          </div>
        </motion.div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="backdrop-blur-xl bg-black/60 rounded-2xl p-6 border border-orange-500/30 shadow-xl hover:shadow-2xl hover:border-orange-400/50 transition-all duration-300"
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="text-orange-400 text-lg fill-current" />
                ))}
              </div>
              <p className="text-gray-200 mb-4 italic leading-relaxed">"{testimonial.text}"</p>
              <div className="text-orange-200 font-medium">
                — {testimonial.author}, {testimonial.location}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;